import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import A1 from "../Images/WhatsApp Image 2026-01-20 at 12.46.23 PM.jpeg";

const Payment = () => {
    const navigate = useNavigate();

    const [form, setForm] = useState({
        agency: "",
        membership_id: "",   // ✅ ADD THIS
        utr: "",
        amount: "",
        validity: "",
        paidOn: "",
        bank: "",
        paymentMode: "",
    });

    const [dataGet, setDataGet] = useState([]);
    const [search, setSearch] = useState("");
    const [editIndex, setEditIndex] = useState(null);
    const [page, setPage] = useState(1);
    const [showModal, setShowModal] = useState(false);

    const [agencies, setAgencies] = useState([]);

    useEffect(() => {
        fetchData();
        fetchDataGet();
    }, []);

    const fetchData = () => {
        fetch("https://taaiappapi.emedha.in/pages/api/api/agency")
            .then((res) => res.json())
            .then((result) => {
                setAgencies(result);
            })
            .catch((err) => {
                console.error(err);
            });
    };

    const fetchDataGet = () => {
        fetch("https://taaiappapi.emedha.in/pages/api/get/agency_members")
            .then((res) => res.json())
            .then((result) => {
                setDataGet(result);
            })
            .catch((err) => {
                console.error(err);
            });
    };


    const handleBackToDashboard = () => {
        navigate("/agency-dashboard", { replace: true });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "agency") {
            const selectedAgency = agencies.find(a => a.agency_name === value);
            setForm({
                ...form,
                agency: value,
                membership_id: selectedAgency ? selectedAgency.membership_id : ""
            });
        } else {
            setForm({ ...form, [name]: value });
        }
    };

    const handleOpenModal = (item = null) => {
        if (item) {
            setForm({
                agency: item.pay_agency_name,
                membership_id: item.pay_membership_id, // ✅ ADD THIS LINE
                utr: item.pay_utr,
                amount: item.pay_amount,
                validity: item.pay_validity ? item.pay_validity.split("T")[0] : "",
                paidOn: item.pay_paid_on ? item.pay_paid_on.split("T")[0] : "",
                bank: item.pay_bank_details,
                paymentMode: item.pay_payment_mode
            });
            setEditIndex(item.id);
        } else {
            setForm({
                agency: "",
                utr: "",
                amount: "",
                validity: "",
                paidOn: "",
                bank: "",
                paymentMode: ""
            });
            setEditIndex(null);
        }
        setShowModal(true);
    };

    const handleSubmit = () => {
        if (!form.agency || !form.amount) {
            alert("Agency and Amount required!");
            return;
        }

        const payload = {
            agency_name: form.agency,
            membership_id: form.membership_id, // ✅ CHANGE THIS: Use the state value
            utr: form.utr,
            amount: form.amount,
            payment_mode: form.paymentMode,
            paid_on: form.paidOn,
            validity: form.validity,
            bank_details: form.bank
        };

        if (editIndex !== null) {
            fetch(`https://taaiappapi.emedha.in/pages/api/update/agency_members/${editIndex}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            })
                .then(res => res.json())
                .then(() => {
                    fetchDataGet();
                    setShowModal(false);
                });
        } else {
            // This will now call your POST route which performs an UPDATE by membership_id
            fetch("https://taaiappapi.emedha.in/pages/api/add/agency_members", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            })
                .then(res => res.json())
                .then((data) => {
                    if (data.error || data.message.includes("failed")) {
                        alert(data.message);
                    } else {
                        fetchDataGet();
                        setShowModal(false);
                    }
                });
        }
    };

    const handleSearch = (e) => {
        setSearch(e.target.value);
        setPage(1);
    };

    const filtered = dataGet.filter((d) => {
        const hasAgencyName = d.pay_agency_name && d.pay_agency_name.trim() !== "";
        const matchesSearch = (d.pay_agency_name || "")
            .toLowerCase()
            .includes(search.toLowerCase());
        return hasAgencyName && matchesSearch;
    });

    const perPage = 10;
    const totalPages = Math.ceil(filtered.length / perPage);
    const paginated = filtered.slice((page - 1) * perPage, (page - 1) * perPage + perPage);

    return (
        <div className="dashboard-container">
            {/* HEADER SECTION */}
            <header className="main-header">
                <div className="brand">
                    <div className="logo-container">
                        <img src={A1} alt="Logo" className="logo" />
                    </div>
                    <div className="title-group">
                        <h1>Travel Agents Association of India</h1>
                        <p>Financial Management & Payment Portal</p>
                    </div>
                </div>
                <button className="btn-back" onClick={handleBackToDashboard}><span>←</span> Back to Dashboard</button>
            </header>

            {/* TOP ACTION BAR */}
            <div className="action-bar">
                <button className="btn-add-payment" onClick={() => handleOpenModal()}>+ Create New Entry</button>
            </div>

            <div className="content-grid">
                <section className="card table-section">
                    <div className="table-header">
                        <div className="search-box">
                            <input className="search-input" placeholder="Search by agency name..." value={search} onChange={handleSearch} />
                        </div>
                        <div className="stats">Total: <strong>{filtered.length}</strong> Records</div>
                    </div>

                    <div className="table-responsive">
                        <table>
                            <thead>
                                <tr>
                                    <th>Agency</th>
                                    <th>UTR Number</th>
                                    <th>Amount</th>
                                    <th>Payment Mode</th>
                                    <th>Validity</th>
                                    <th>Payment Date</th>
                                    <th>Bank Details</th>
                                    <th style={{ textAlign: 'right' }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginated.length > 0 ? paginated.map((item, index) => {
                                    const originalIndex = (page - 1) * perPage + index;
                                    return (
                                        <tr key={originalIndex}>
                                            <td className="fw-600">{item.pay_membership_id} - {item.pay_agency_name}</td>
                                            <td>{item.pay_utr || ''}</td>
                                            <td>₹{Number(item.pay_amount).toLocaleString()}</td>
                                            <td>{item.pay_payment_mode || '-'}</td>
                                            <td>{item.pay_validity ? new Date(item.pay_validity).toLocaleString() : "-"}</td>
                                            <td>{item.pay_paid_on ? new Date(item.pay_paid_on).toLocaleString() : "-"}</td>
                                            <td>{item.pay_bank_details}</td>
                                            <td style={{ textAlign: 'right' }}>
                                                <div className="action-btns">
                                                    <button className="edit-link" onClick={() => handleOpenModal(item)}>Edit</button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                }) : (
                                    <tr><td colSpan="7" className="no-data">No records found matching your search.</td></tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* PAGINATION CONTROLS */}

                    <div className="pagination-container">
                        <span className="page-info">Showing {paginated.length} of {filtered.length} entries</span>
                        <div className="pagination">
                            <button disabled={page === 1} onClick={() => setPage(page - 1)} className="page-nav">Prev</button>
                            {[...Array(totalPages)].map((_, i) => (<button key={i} className={page === i + 1 ? "active" : ""} onClick={() => setPage(i + 1)} >{i + 1}</button>))}
                            <button disabled={page === totalPages} onClick={() => setPage(page + 1)} className="page-nav">Next</button>
                        </div>
                    </div>

                </section>
            </div>

            {/* IMPROVED MODAL FORM DESIGN */}
            {showModal && (
                <div className="modal-overlay">
                    <div className="modal-card">
                        <div className="modal-header">
                            <div>
                                <h3 className="modal-title">{editIndex !== null ? "Update Payment Record" : "New Payment Entry"}</h3>
                                <p className="modal-subtitle">Ensure all bank transaction details are accurate.</p>
                            </div>
                            <button className="close-modal" onClick={() => setShowModal(false)}>&times;</button>
                        </div>

                        <div className="modal-body">
                            <div className="form-grid">
                                {/* Agency Name Field */}
                                <div className="input-group col-span-2">
                                    <label>Agency Name</label>
                                    {editIndex !== null ? (
                                        // When EDITING: Show a read-only input or text so they can't change the agency
                                        <input
                                            type="text"
                                            value={`${form.membership_id} - ${form.agency}`}
                                            disabled
                                            className="disabled-input"
                                            style={{ backgroundColor: '#f0f0f0', cursor: 'not-allowed' }}
                                        />
                                    ) : (
                                        // When CREATING NEW: Show dropdown but FILTER OUT agencies that already have payments
                                        <select name="agency" value={form.agency} onChange={handleChange}>
                                            <option value="">Select Agency</option>
                                            {agencies
                                                .filter(agency =>
                                                    // Only show agencies whose membership_id IS NOT already in dataGet
                                                    !dataGet.some(payment => payment.pay_membership_id === agency.membership_id)
                                                )
                                                .map((agency, index) => (
                                                    <option key={index} value={agency.agency_name}>
                                                        {agency.membership_id} - ({agency.agency_name})
                                                    </option>
                                                ))
                                            }
                                        </select>
                                    )}
                                </div>

                                {/* UTR */}
                                <div className="input-group">
                                    <label>UTR Number</label>
                                    <input name="utr" placeholder="TXN12345678" value={form.utr} onChange={handleChange} />
                                </div>
                                {/* Amount */}
                                <div className="input-group">
                                    <label>Amount (₹)</label>
                                    <input name="amount" type="number" placeholder="0.00" value={form.amount} onChange={handleChange} />
                                </div>
                                {/* Payment Mode (RIGHT AFTER AMOUNT) */}
                                <div className="input-group">
                                    <label>Payment Mode</label>
                                    <select name="paymentMode" value={form.paymentMode} onChange={handleChange} >
                                        <option value="">Select Mode</option>
                                        <option value="UPI">UPI</option>
                                        <option value="CHEQUE">CHEQUE</option>
                                        <option value="CASH">CASH</option>
                                    </select>
                                </div>
                                {/* Paid On (NEXT) */}
                                <div className="input-group">
                                    <label>Paid On</label>
                                    <input type="date" name="paidOn" value={form.paidOn} onChange={handleChange} />
                                </div>
                                {/* Validity (AFTER PAID ON) */}
                                <div className="input-group">
                                    <label>Validity Date</label>
                                    <input type="date" name="validity" value={form.validity} onChange={handleChange} />
                                </div>
                                {/* Bank Details (LAST) */}
                                <div className="input-group">
                                    <label>Bank Details</label>
                                    <input name="bank" placeholder="Bank / UPI / Cheque details" value={form.bank} onChange={handleChange} />
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button className="btn-cancel" onClick={() => setShowModal(false)}>Cancel</button>
                            <button className="btn-save" onClick={handleSubmit}>{editIndex !== null ? "Update Record" : "Save Transaction"}</button>
                        </div>
                    </div>
                </div>
            )}

            <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

        .dashboard-container {
          padding: 24px; background: #f1f5f9; min-height: 100vh;
          font-family: 'Inter', sans-serif; font-size: 13px; color: #334155;
        }

        /* HEADER */
        .main-header {
          display: flex; justify-content: space-between; align-items: center;
          padding: 16px 24px; background: white; border-radius: 12px;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1); margin-bottom: 24px;
        }
        .brand { display: flex; align-items: center; gap: 20px; }
        .logo-container { padding-right: 20px; border-right: 1px solid #e2e8f0; }
        .logo { height: 50px; display: block; }
        .title-group h1 { font-size: 18px; margin: 0; color: #0f172a; font-weight: 700; letter-spacing: -0.025em; }
        .title-group p { font-size: 12px; margin: 2px 0 0; color: #64748b; }
        .btn-back {
          background: #f8fafc; border: 1px solid #e2e8f0; padding: 8px 16px;
          border-radius: 8px; font-size: 12px; font-weight: 600; cursor: pointer;
        }

        .action-bar { margin-bottom: 20px; }
        .btn-add-payment {
          background: #4f46e5; color: white; border: none; padding: 12px 24px;
          border-radius: 8px; cursor: pointer; font-weight: 600; 
          box-shadow: 0 10px 15px -3px rgba(79, 70, 229, 0.3);
        }

        .card { background: white; border-radius: 12px; border: 1px solid #e2e8f0; }

        /* TABLE */
        .table-header { padding: 20px; display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #f1f5f9; }
        .search-input { width: 300px; padding: 10px 16px; border: 1px solid #e2e8f0; border-radius: 8px; background: #f8fafc; outline: none; }
        .table-responsive { overflow-x: auto; }
        table { width: 100%; border-collapse: collapse; }
        th { background: #f8fafc; padding: 14px 20px; text-align: left; font-size: 11px; font-weight: 700; color: #64748b; text-transform: uppercase; }
        td { padding: 16px 20px; border-bottom: 1px solid #f1f5f9; }
        .fw-600 { font-weight: 600; color: #1e293b; }
        .color-primary { color: #4f46e5; }
        .badge-utr { background: #f1f5f9; padding: 4px 8px; border-radius: 6px; font-family: monospace; }
        .action-btns { display: flex; gap: 12px; justify-content: flex-end; }
        .edit-link { color: #4f46e5; border: none; background: #eef2ff; padding: 6px 12px; border-radius: 6px; cursor: pointer; font-weight: 600; }
        .delete-link { color: #ef4444; border: none; background: #fef2f2; padding: 6px 12px; border-radius: 6px; cursor: pointer; font-weight: 600; }

        /* PAGINATION */
        .pagination-container { padding: 20px; display: flex; justify-content: space-between; align-items: center; border-top: 1px solid #f1f5f9; }
        .pagination { display: flex; gap: 6px; }
        .pagination button { 
            min-width: 36px; height: 36px; border: 1px solid #e2e8f0; background: white; 
            border-radius: 8px; cursor: pointer; font-weight: 500; color: #64748b;
        }
        .pagination button.active { background: #4f46e5; color: white; border-color: #4f46e5; }
        .page-nav { padding: 0 12px; }

        /* MODAL DESIGN */
        .modal-overlay {
          position: fixed; top: 0; left: 0; width: 100%; height: 100%;
          background: rgba(15, 23, 42, 0.6); backdrop-filter: blur(4px);
          display: flex; align-items: center; justify-content: center; z-index: 1000;
        }
        .modal-card { 
          background: white; width: 550px; max-width: 95%; border-radius: 16px; 
          box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1); overflow: hidden;
          animation: slideUp 0.3s ease-out;
        }
        @keyframes slideUp {
          from { transform: translateY(20px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        .modal-header { padding: 20px 24px; border-bottom: 1px solid #f1f5f9; display: flex; justify-content: space-between; align-items: center; }
        .modal-title { font-size: 18px; font-weight: 700; color: #0f172a; margin: 0; }
        .modal-subtitle { font-size: 12px; color: #64748b; margin: 4px 0 0; }
        .close-modal { font-size: 28px; color: #94a3b8; border: none; background: none; cursor: pointer; }
        .modal-body { padding: 24px; }
        
        .form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
        .col-span-2 { grid-column: span 2; }
        
        .input-group { display: flex; flex-direction: column; gap: 6px; }
        .input-group label { font-size: 12px; font-weight: 600; color: #475569; }
        .input-group input, .input-group select { 
            padding: 10px 14px; border: 1px solid #e2e8f0; border-radius: 8px; 
            font-size: 14px; background: #f8fafc; outline: none; transition: 0.2s;
        }
        .input-group input:focus { border-color: #4f46e5; background: white; box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1); }

        .modal-footer { padding: 16px 24px; background: #f8fafc; border-top: 1px solid #f1f5f9; display: flex; justify-content: flex-end; gap: 12px; }
        .btn-cancel { background: white; border: 1px solid #e2e8f0; color: #64748b; padding: 10px 20px; border-radius: 8px; font-weight: 600; cursor: pointer; }
        .btn-save { background: #4f46e5; border: none; color: white; padding: 10px 24px; border-radius: 8px; font-weight: 600; cursor: pointer; }
      `}</style>
        </div>
    );
};

export default Payment;